var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ws-badge",class:{ hasIcon: _vm.icon, tertiary: _vm.tertiary }},[_c('span',{staticClass:"content"},[(_vm.check)?_c('q-icon',{staticClass:"check-icon",attrs:{"name":_vm.mdiCheck,"size":"100%"}}):(_vm.icon)?_c('ws-icon',{attrs:{"size":"100%","name":_vm.icon}}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }